const TYPEAHEAD_LOCATION_CONFIG = {
    endpoint: {
        hotels: '/svcs/ac/index/hotels/',
        hotelsV2: '/svcs/ac/index/hotels/v2/',
        cars: '/pws/v0/index/drive/search/',
        packagesOrigin: '/pws/v0/typeahead/vacation-packages/',
        packagesDestination: '/pws/v0/index/relax/search/',
        flights: '/svcs/ac/index/flights/'
    },
    suffix: {
        hotels: '/6/3/3/3',
        hotelsV2: '',
        packagesOrigin: '/6/3/0/0',
        packagesDestination: '/6/3/0/0',
        flights: '/0/9/0/0'
    },
    querystring: {
        cars: '?numCities=6&numAirports=5&numPOIs=3&numPartnerLocations=4'
    }
};
const TYPEAHEAD_FEEDBACK_CONFIG = {
    flights: '/svcs/ac/index/feedback/flights',
    cars: '/pws/v0/index/drive/feedback',
    hotels: '/svcs/ac/index/feedback/hotels',
    hotelsV2: '/svcs/ac/index/feedback/hotels',
    packagesOrigin: '/svcs/ac/index/feedback/vacation-packages',
    packagesDestination: ''
};
const NEAREST_CITY_BASE_URL = '/svcs/ac/index/hotels/rtlsearch/';
const TYPEAHEAD_PLACE_TYPE_CODE = {
    AIRPORT: 'A',
    CITY: 'C',
    HOTEL: 'H',
    POI: 'P',
    GEO: 'GEO',
    LATLON: 'LATLON',
    PARTNER_LOC: 'PARTNER_LOC',
    GDS_CITY: 'GDS_CITY',
    ADDRESS: 'ADDRESS',
    HOTEL_CITY: 'HOTEL_CITY',
    NEIGHBOURHOOD: 'N',
    AI_QUERY: 'Q'
};
function resolveTypeAheadUrl({ endpointKey, query, config }) {
    const base = config?.endpoint?.[endpointKey] ?? TYPEAHEAD_LOCATION_CONFIG.endpoint[endpointKey];
    const isCars = 'cars' === endpointKey;
    const suffix = isCars ? '' : config?.suffix?.[endpointKey] ?? TYPEAHEAD_LOCATION_CONFIG.suffix[endpointKey];
    const querystring = isCars ? config?.querystring?.cars ?? TYPEAHEAD_LOCATION_CONFIG.querystring.cars : '';
    return `${base}${encodeURIComponent(query)}${suffix}${querystring}`;
}
function resolveFeedbackUrl({ endpointKey, config }) {
    return config?.feedback?.[endpointKey] ?? TYPEAHEAD_FEEDBACK_CONFIG[endpointKey];
}
function appendQueryFlag(url, flag) {
    return `${url}${url.includes('?') ? '&' : '?'}${flag}`;
}
export { NEAREST_CITY_BASE_URL, TYPEAHEAD_FEEDBACK_CONFIG, TYPEAHEAD_LOCATION_CONFIG, TYPEAHEAD_PLACE_TYPE_CODE, appendQueryFlag, resolveFeedbackUrl, resolveTypeAheadUrl };
